import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
// ✅ Async Thunk
export const fetchEmailMarketingReport = createAsyncThunk("emailMarketing/fetchReport", async (params, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const response = await ApiCall("POST", "/api/email-marketing-report", params, {
            Authorization: token || ""
        });
        if (response && 'data' in response && response.data?.success) {
            return response.data;
        }
        if (response && response.isAxiosError) {
            const axiosErr = response;
            return rejectWithValue(axiosErr.response?.data?.message || "Failed to fetch email marketing report");
        }
        return rejectWithValue(response?.data?.message || "Failed to fetch email marketing report");
    }
    catch (error) {
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "An error occurred");
    }
});
// ✅ Initial State
const initialState = {
    data: null,
    loading: false,
    error: null,
};
// ✅ Slice
const emailMarketingSlice = createSlice({
    name: "emailMarketing",
    initialState,
    reducers: {
        clearEmailMarketingData: (state) => {
            state.data = null;
            state.error = null;
        },
        clearEmailMarketingError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmailMarketingReport.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchEmailMarketingReport.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            // state?.data.lastUpdated = action.payload.lastUpdated;
            state.error = null;
        })
            .addCase(fetchEmailMarketingReport.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch report";
        });
    },
});
// ✅ Actions
export const { clearEmailMarketingData, clearEmailMarketingError } = emailMarketingSlice.actions;
// ✅ Selectors
export const selectEmailMarketingData = (state) => state.emailMarketing.data;
export const selectEmailMarketingLoading = (state) => state.emailMarketing.loading;
export const selectEmailMarketingError = (state) => state.emailMarketing.error;
export default emailMarketingSlice.reducer;
